import request from '../../utils/request.jsx';


// 加入我们 页面 信息
export const getJoinWeData = () => {
  return request('/join/select');
}

